module.exports = __webpack_public_path__ + "img/violet_127.092c858f.png";